const playground = {
  title: 'Playground',
  description: 'Test and explore your Knowledge Base in real time',
  welcomeMessage: 'Welcome to the Knowledge Base Playground!',
  welcomeDescription: 'Here you can interact directly with your Knowledge Base. Ask questions, test scenarios and explore the system capabilities.',
  inputPlaceholder: 'Type your message to the Knowledge Base...',
  sendMessage: 'Send message',
  noWorkspaceSelected: 'No workspace selected',
  selectWorkspaceFirst: 'Select a workspace to start using the Playground',
  connecting: 'Connecting...',
  connected: 'Connected',
  disconnected: 'Disconnected',
  reconnecting: 'Reconnecting...',
  connectionError: 'Connection error',
  retryConnection: 'Try again',
  chatHistory: 'Chat History',
  clearChat: 'Clear Chat',
  error: 'Error',
  typing: 'Typing...',
  userJoined: '{username} joined the chat',
  userLeft: '{username} left the chat',
  playgroundAI: 'Playground AI',
  you: 'You',

  // Conversation history sidebar (v2)
  sidebar: {
    newChat: 'New conversation',
    search: 'Search conversation…',
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Previous 7 days',
    older: 'Older',
    empty: 'No conversations yet',
    noResults: 'No conversations found',
  },

  // PlaygroundView specific
  view: {
    title: 'Playground',
    subtitle: 'Chat with your AI in real time',
    conversation: 'Conversation: ',
    newChat: 'New Chat',
    settings: 'Playground Settings',
    shareConversation: 'Share conversation as PDF',
    emptyStateTitle: 'How can I help you with your project?',
    emptyStateSubtitle: 'Choose a suggestion below or type your own question',
    emptyChatTitle: 'Empty Chat',
    emptyChatSubtitle: 'Send your first message to start the conversation.',
    aiThinking: 'Thinking...',
    selectingAgents: 'Selecting agents...',
    sendButton: 'Send',
    inputPlaceholder: 'Type your message to the AI...',
    keyboardShortcuts: 'Press Enter to send, Shift + Enter for new line',
    noLlmTitle: 'No LLM model configured',
    noLlmDescription: 'To chat in the Playground, configure an LLM model in an Integration, or set an Integration as the organization default model.'
  },

  // Prompt suggestions
  suggestions: {
    projectAnalysis: {
      title: 'Project Analysis',
      description: 'Evaluate strengths, weaknesses and opportunities',
      prompt: 'Perform a detailed analysis of my project, including strengths, weaknesses and improvement opportunities'
    },
    executivePresentation: {
      title: 'Executive Presentation',
      description: 'Create a presentation for stakeholders',
      prompt: 'Create an executive presentation outline about my project for stakeholders, including metrics and next steps'
    },
    projectStory: {
      title: 'Project Story',
      description: 'Create an engaging narrative about the project',
      prompt: 'Tell my project\'s story in an engaging way, highlighting its journey, evolution and market impact'
    },
    competitorAnalysis: {
      title: 'Competitor Analysis',
      description: 'Compare with competition and identify differentiation',
      prompt: 'Develop a comparative analysis of my project\'s main competitors, including differentiation and positioning'
    },
    marketingStrategy: {
      title: 'Marketing Strategy',
      description: 'Develop campaigns and identify ideal channels',
      prompt: 'Suggest a digital marketing strategy for my project, including channels, messages and target audience'
    },
    projectFAQ: {
      title: 'Project FAQ',
      description: 'Generate frequently asked questions with answers',
      prompt: 'Create a list of frequently asked questions (FAQ) about my project with detailed answers for customers'
    }
  },

  // ChatList specific
  chatList: {
    title: 'Chat History',
    description: 'Manage your chat sessions with the Knowledge Base',
    newChat: 'New Chat',
    noChatsYet: 'No chats yet',
    createFirstChat: 'Create your first chat or send a message to get started',
    renameChat: 'Rename Chat',
    archiveChat: 'Archive Chat',
    deleteChat: 'Delete Chat',
    deleteConfirmTitle: 'Delete chat?',
    deleteConfirmDescription: 'This action cannot be undone. The chat and all its history will be permanently deleted.',
    chatDeleted: 'Chat deleted successfully',
    chatArchived: 'Chat archived successfully',
    chatRenamed: 'Chat renamed successfully',
    chatCreated: 'New chat created',
    createError: 'Error creating chat',
    renameError: 'Error renaming chat',
    archiveError: 'Error archiving chat',
    deleteError: 'Error deleting chat',
    emptyTitleError: 'Title cannot be empty',
    titleTooLongError: 'Title cannot be longer than 255 characters',
    showFullHistory: 'Show full history',
    chatActions: 'Chat actions',
    messageCount: {
      singular: 'message',
      plural: 'messages'
    },
    activeChats: {
      singular: 'active chat',
      plural: 'active chats'
    },
    timeAgo: 'Now'
  },

  // ChatMessage specific
  message: {
    shareTitle: 'Share message',
    favoriteTitle: 'Favorite message',
    copyTitle: 'Copy message',
    you: 'You',
    aiResponseTitle: 'AI Response - {name}'
  },

  // PlaygroundConfigDialog specific
  config: {
    title: 'Playground Settings',
    loading: 'Loading settings...',
    saving: 'Saving...',
    saved: 'Settings saved',
    savedDescription: 'Playground settings have been successfully updated.',
    reset: 'Reset',
    cancel: 'Cancel',
    save: 'Save',
    tabs: {
      rag: 'RAG & AI',
      ui: 'Interface',
      restrictions: 'Restrictions'
    },
    rag: {
      title: 'RAG and AI Settings',
      similarityThreshold: 'Similarity Threshold',
      maxResults: 'Maximum Results',
      temperature: 'Temperature',
      maxTokens: 'Maximum Tokens',
      systemPrompt: 'System Prompt',
      systemPromptPlaceholder: 'Define the AI behavior and role...'
    },
    ui: {
      title: 'Interface Settings',
      welcomeMessage: 'Welcome Message',
      welcomeMessagePlaceholder: 'Message displayed when user opens the chat...',
      inputPlaceholder: 'Input Placeholder',
      inputPlaceholderPlaceholder: 'Placeholder text for the input field...',
      maxChatHistory: 'Maximum Chat History'
    },
    restrictions: {
      title: 'Restrictions and Limits',
      allowedFileTypes: 'Allowed File Types',
      allowedFileTypesPlaceholder: 'pdf, txt, docx, xlsx...',
      allowedFileTypesHelp: 'Separate file types with commas',
      maxQueryLength: 'Maximum Query Length (characters)',
      rateLimitPerMinute: 'Query Limit per Minute'
    }
  },

  // Error messages
  errors: {
    general: 'An error occurred',
    sendMessage: 'Error sending message',
    loadHistory: 'Error loading chat history',
    loadConfig: 'Error loading settings',
    saveConfig: 'Error saving settings',
    subscriptionRequired: 'Subscription Expired/Exhausted - Add more credits or upgrade your plan to continue chatting.'
  },

  // No workspace state
  no_workspace: {
    title: 'No workspace selected',
    description: 'Select a workspace to start using the Playground'
  },

  // Loading states
  loading: {
    history: {
      title: "Loading history...",
      description: "Retrieving your previous conversations with the AI"
    }
  },

  // Legacy support
  manageChatSessions: 'Manage your chat sessions with the Knowledge Base',
  newChat: 'New Chat',
  creatingChat: 'Creating...',
  noChatsYet: 'No chats yet',
  createFirstChat: 'Create your first chat or send a message to get started',
  renameChat: 'Rename Chat',
  archiveChat: 'Archive Chat',
  deleteChat: 'Delete Chat',
  deleteConfirmTitle: 'Delete chat?',
  deleteConfirmDescription: 'This action cannot be undone. The chat and all its history will be permanently deleted.',
  chatDeleted: 'Chat deleted successfully',
  chatArchived: 'Chat archived successfully',
  chatRenamed: 'Chat renamed successfully',
  chatCreated: 'New chat created',
  emptyStateTitle: 'Welcome to Playground!',
  emptyStateDescription: 'Select an existing conversation or send a message to start a new one.',
  emptyChat: 'Empty chat',
  startConversation: 'Send your first message to start the conversation',
  no_agent_selected: "Type your question to get started",
  ai_thinking: "AI is processing your question...",

  // Chat structure
  chat: {
    input_placeholder: 'Type your message to the Knowledge Base...',
    send: 'Send'
  },

  // MCP Tools discovery
  mcpTools: {
    title: 'MCP Tools',
    openDialog: 'View all MCP tools and configuration',
    tabs: {
      integrations: 'Integrations',
      core: 'Core Tools',
      config: 'Config'
    },
    integrations: {
      empty: 'No integrations with MCP tools installed for this workspace.',
      toolCount_one: '{{count}} tool',
      toolCount_other: '{{count}} tools'
    },
    coreGroups: {
      contextKnowledge: 'Context & Knowledge',
      agents: 'Agents',
      integrations: 'Integrations',
      admin: 'Admin (SUPERADMIN / ADMIN)'
    },
    coreTools: {
      get_my_profile: "Authenticated user identity, organization and personal AI preferences.",
      get_workspace_info: "Full workspace context (knowledge base overview + active integrations).",
      update_my_ai_preferences: "Update the user's personal AI instructions and destructive-action confirmation flag.",
      search_knowledge: "Semantic RAG search across the knowledge base.",
      list_agents: 'List AI agents configured for this workspace.',
      invoke_agent: 'Run a Prodgy agent with its own LLM, tools and prompt.',
      list_integration_catalog: 'Browse available integration templates.',
      list_installed_integrations: 'Installed integrations with status and tools.',
      get_integration: 'Full template details: auth, settings, mcp_config.',
      install_integration: 'Provision an integration with credentials and settings.',
      create_integration: 'Create a new integration template in the catalog.',
      update_integration: 'Update an existing integration template.',
      delete_integration: 'Remove an integration template from the catalog.',
      get_mcp_settings: 'Read current MCP server instructions and export rules.',
      update_mcp_settings: 'Update MCP server instructions and export rules.'
    },
    config: {
      descriptionPrefix: 'Add this snippet to your MCP client config (',
      descriptionSuffix: ').',
      tokenHintPrefix: 'Generate a token in ',
      tokenHintBold: 'Workspace Settings → API Tokens',
      tokenHintSuffix: '.',
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: 'Failed to copy to clipboard'
    }
  },

  // Embed Widget
  embedWidget: {
    title: 'Embed Widget',
    subtitle: 'Embed chat widget for',
    embedButton: 'Embed Widget',
    customize: 'Customize',
    widgetTitle: 'Widget Title',
    width: 'Width (px)',
    height: 'Height (px)',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    embedCode: 'Embed Code',
    iframeDescription: 'Paste this code into your HTML page to embed the chat widget.',
    scriptDescription: 'Add this script to your page for an auto-loading floating chat widget.',
    directUrl: 'Direct URL',
    codeCopied: 'Code copied',
    codeCopiedDescription: 'The embed code has been copied to clipboard.',
    copyFailed: 'Failed to copy'
  }
} as const;

export default playground;
